import { ComponentProps } from "@declarations/props";

export const SemiCircle: ComponentProps = () => {
  return (
    <div className="bg-semi-circle tw-bg-primary tw-h-[400px]">
      <svg
        className="curve"
        viewBox="0 0 100 12"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: "-1px",
          left: "0",
          width: "100%",
          height: "100px",
        }}
      >
        <path d="M0,0 Q50,3 100,0 L100,30 L0,30 Z" fill="#f7f7f8" />
      </svg>
    </div>
  );
};
